import { render, staticRenderFns } from "./customizer.vue?vue&type=template&id=034b1aa4"
import script from "./customizer.vue?vue&type=script&lang=js"
export * from "./customizer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports